import store from "../store/store.js";
import Vue from "vue";

export var Api = {

	initializationStarted: false,
	pendingRequests: 0,

	prepareInitialization() {
		Api.initializationStarted = false;
		Api.pendingRequests = 0;
	},

	initializationCompleted() {
		return Api.initializationStarted && Api.pendingRequests === 0;
	},

	post(context, path, data, onSuccess, onError, options) {
		Api.request(context, path, data, "POST", onSuccess, onError, options);
	},

	get(context, path, onSuccess, onError, options) {
		Api.request(context, path, {}, "GET", onSuccess, onError, options);
	},

	async syncGet(context, path, onSuccess, onError) {
		Api.requestStarted();
		Api.initializationStarted = true;

		const url = process.env.VUE_APP_API_URL + path;
		await context.$http.get(url).then(response => {
			context.errorResponse = undefined;
			context.submitSuccess = true;
			Api.requestEnded();
			if (typeof onSuccess === "function") {
				onSuccess(response.body);
			}
		}, errorResponse => {
			context.errorResponse = errorResponse.body;
			context.submitSuccess = false;
			Api.requestEnded();

			if (errorResponse.status === 403) {
				context.$router.push("/forbidden");
				return;
			}

			if (typeof onError === "function") {
				onError(errorResponse.body);
			}
		});
	},

	getWithParam(context, path, data, onSuccess, onError, options) {
		Api.request(context, path, data, "GET", onSuccess, onError, options);
	},

	put(context, path, data, onSuccess, onError, options) {
		Api.request(context, path, data, "PUT", onSuccess, onError, options);
	},

	delete(context, path, data, onSuccess, onError, options) {
		Api.request(context, path, data, "DELETE", onSuccess, onError, options);
	},

	postMultipart(context, path, file, data, onSuccess, onError, options) {
		options = options ? options : {};
		options.headers = options.headers ? options.headers : {};
		options.headers["Content-Type"] = "multipart/form-data";

		let formData = new FormData();
		if (file instanceof Array) {
			for (let i = 0; i < file.length; ++i) {
				formData.append("file", file[i]);
			}
		} else {
			formData.append("file", file);
		}

		for (const [key, value] of Object.entries(data)) {
			formData.append(key, value);
		}

		Api.post(context, path, formData, onSuccess, onError, options);
	},

	ignoresLoader(options) {
		return (options && options.ignoreLoader);
	},


	requestStarted(options) {
		if (!Api.ignoresLoader(options)) {
			Api.pendingRequests = Api.pendingRequests + 1;
			Api.updateState();
		}
	},

	requestEnded(options) {
		if (!Api.ignoresLoader(options)) {
			Api.pendingRequests = Api.pendingRequests - 1;
			Api.updateState();
		}
	},

	updateState() {
		if (Api.pendingRequests > 0) {
			store.commit("loader", true);
		} else {
			store.commit("loader", false);
		}
	},

	request(context, path, data, method, onSuccess, onError, options) {
		Api.requestStarted(options);
		Api.initializationStarted = true;

		const url = process.env.VUE_APP_API_URL + path;

		const successHandler = response => {
			context.errorResponse = undefined;
			context.submitSuccess = true;
			Api.requestEnded(options);
			if (typeof onSuccess === "function") {
				onSuccess(response.body);
			}
		};

		const errorHandler = errorResponse => {
			Api.requestEnded(options);
			context.errorResponse = errorResponse.body;
			context.submitSuccess = false;

			if (errorResponse.status === 401) {
				Vue.prototype.$keycloak.login({ redirectUri: document.location.href });
				return;
			}

			if (errorResponse.status === 403) {
				context.$router.push("/forbidden");
				return;
			}
			if (typeof onError === "function") {
				onError(errorResponse.body);
			}
		};

		if (method === "POST") {
			context.$http.post(url, data, options).then(successHandler, errorHandler);
		} else if (method === "GET") {
			context.$http.get(url, {params: data}, options).then(successHandler, errorHandler);
		} else if (method === "DELETE") {
			context.$http.delete(url, {body: data}, options).then(successHandler, errorHandler);
		} else if (method === "PUT") {
			context.$http.put(url, data, options).then(successHandler, errorHandler);
		}
	},

};
